import { render, staticRenderFns } from "./ShopCheckoutSummary.vue?vue&type=template&id=2f80081a&scoped=true"
import script from "./ShopCheckoutSummary.vue?vue&type=script&lang=js"
export * from "./ShopCheckoutSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f80081a",
  null
  
)

export default component.exports